<template>
    <div>
    </div>
</template>

<script>
import carbonRegistry from "@/api/carbonRegistry.js";
export default {
    name: 'Maps',

    data() {
        return {
            
        };
    },

    mounted() {
        this.getMapDetails()
    },

    methods: {
        getMapDetails(){
            let data = JSON.parse(sessionStorage.getItem('login'))
            carbonRegistry.getLatDetail(responses =>{
                if(responses.code == 200){
                    this.initMap(responses.data)
                }
            },{country:data.country ? data.country : 'Indonesia',groupId:data.groupId ? data.groupId : ''})
        },
        initMap(data) {
            //多点位
            const map = new google.maps.Map(document.getElementById("maps"), {
                center: new google.maps.LatLng(data.initialLatitude, data.initialLongitude),
                zoom: 4,
            });
            let features = [];
            for(let i = 0 ; i < data.list.length ; i++){
                features.push({
                    position:new google.maps.LatLng(data.list[i].latitude, data.list[i].longitude),
                    type:"info"
                })
            }
            for (let j = 0; j < features.length; j++) {
                const marker = new google.maps.Marker({
                    position: features[j].position,
                    map: map,
                });
            }
        },
    },
};
</script>

<style lang="scss" scoped>

</style>